import React from 'react';
import { Card, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const ChartCard = ({ title, total, children, footer, action }) => {
  return (
    <Card 
      bodyStyle={{ padding: '20px 24px 8px' }} 
      bordered={false}
      style={{ height: '100%' }}
    >
      <div className="chart-card-header">
        <div className="meta">
          <span className="chart-card-title">{title}</span>
          <span className="chart-card-action">
            {action && (
              <Tooltip title="Indicator description">
                <InfoCircleOutlined />
              </Tooltip>
            )}
          </span>
        </div>
        <div className="total">
          <span>{total}</span>
        </div>
      </div>
      
      <div className="chart-card-content">
        <div className="content-fix">
          {children}
        </div>
      </div>
      
      {footer && (
        <div className="chart-card-footer">
          {footer}
        </div>
      )}
    </Card>
  );
};

export default ChartCard;
